// class Store {
//   private static instance: Store;
//   private constructor() {
//     // do something construct...
//   }
//   static getInstance() {
//     if (!Store.instance) {
//       Store.instance = new Store();
//       // ... any one time initialization goes here ...
//     }
//     return Store.instance;
//   }
//   someMethod() { }
// }

import Vue from "vue";
import Vuex, { Store } from "vuex";

Vue.use(Vuex);
const store: any = <Store<any>>new Vuex.Store({});

export default store;
